import { BaseService } from "./BaseService";
import { Measures } from "../types/app.interfaces";
import { FunctionGroup, MeasuresType } from "../types/app.enums";

export class PooledBenchmarkPhase2Service extends BaseService {
  burgissCalcPooledBenchmarkDPI(
    investId?: any[][],
    endDate?: any,
    idType?: string,
    selectionSetId?: any,
    weightingMethod?: any,
    filter?: any,
    currency?: string,
    requireReportedValuation?: any,
    alternateCurrrency?: string,
    uniqueCellId?: string
  ) {
    if (idType == "p") {
      const objRequest = this.createPayload(
        [],
        endDate,
        idType,
        selectionSetId,
        weightingMethod,
        filter,
        currency,
        requireReportedValuation,
        alternateCurrrency,
        investId,
        [],
        MeasuresType.DPI,
        uniqueCellId
      );
      return super._pushOperation(
        "BurgissCalcPooledBenchmarkDPI",
        objRequest,
        this.APICONFIG.GETPOOLEDBENCH,
        FunctionGroup.Pooledbenchmarkphase2
      );
    } else if (idType == "i") {
      const objRequest = this.createPayload(
        investId,
        endDate,
        idType,
        selectionSetId,
        weightingMethod,
        filter,
        currency,
        requireReportedValuation,
        alternateCurrrency,
        [],
        [],
        MeasuresType.DPI,
        uniqueCellId
      );
      return super._pushOperation(
        "BurgissCalcPooledBenchmarkDPI",
        objRequest,
        this.APICONFIG.GETPOOLEDBENCH,
        FunctionGroup.Pooledbenchmarkphase2
      );
    }
    return null;
  }

  burgissCalcPooledBenchmarkTVPI(
    investId?: any[][],
    endDate?: any,
    idType?: string,
    selectionSetId?: any,
    weightingMethod?: any,
    filter?: any,
    currency?: string,
    requireReportedValuation?: any,
    alternateCurrrency?: string,
    uniqueCellId?: string
  ) {
    if (idType == "p") {
      const objRequest = this.createPayload(
        [],
        endDate,
        idType,
        selectionSetId,
        weightingMethod,
        filter,
        currency,
        requireReportedValuation,
        alternateCurrrency,
        investId,
        [],
        MeasuresType.TVPI,
        uniqueCellId
      );
      return super._pushOperation(
        "BurgissCalcPooledBenchmarkTVPI",
        objRequest,
        this.APICONFIG.GETPOOLEDBENCH,
        FunctionGroup.Pooledbenchmarkphase2
      );
    } else if (idType == "i") {
      const objRequest = this.createPayload(
        investId,
        endDate,
        idType,
        selectionSetId,
        weightingMethod,
        filter,
        currency,
        requireReportedValuation,
        alternateCurrrency,
        [],
        [],
        MeasuresType.TVPI,
        uniqueCellId
      );
      return super._pushOperation(
        "BurgissCalcPooledBenchmarkTVPI",
        objRequest,
        this.APICONFIG.GETPOOLEDBENCH,
        FunctionGroup.Pooledbenchmarkphase2
      );
    }
    return null;
  }
  burgissCalcPooledBenchmarkRVPI(
    investId?: any[][],
    endDate?: any,
    idType?: string,
    selectionSetId?: any,
    weightingMethod?: any,
    filter?: any,
    currency?: string,
    requireReportedValuation?: any,
    alternateCurrrency?: string,
    uniqueCellId?: string
  ) {
    if (idType == "p") {
      const objRequest = this.createPayload(
        [],
        endDate,
        idType,
        selectionSetId,
        weightingMethod,
        filter,
        currency,
        requireReportedValuation,
        alternateCurrrency,
        investId,
        [],
        MeasuresType.RVPI,
        uniqueCellId
      );
      return super._pushOperation(
        "BurgissCalcPooledBenchmarkRVPI",
        objRequest,
        this.APICONFIG.GETPOOLEDBENCH,
        FunctionGroup.Pooledbenchmarkphase2
      );
    } else if (idType == "i") {
      const objRequest = this.createPayload(
        investId,
        endDate,
        idType,
        selectionSetId,
        weightingMethod,
        filter,
        currency,
        requireReportedValuation,
        alternateCurrrency,
        [],
        [],
        MeasuresType.RVPI,
        uniqueCellId
      );
      return super._pushOperation(
        "BurgissCalcPooledBenchmarkRVPI",
        objRequest,
        this.APICONFIG.GETPOOLEDBENCH,
        FunctionGroup.Pooledbenchmarkphase2
      );
    }
    return null;
  }
  createPayload(
    investId: any[][] = null,
    endDate: any = null,
    idType: string = null,
    selectionSetId: any = null,
    weightingMethod: any = null,
    filter: any = "",
    currency: string = null,
    requireReportedValuation: any = null,
    alternateCurrrency: string = null,
    portfolioId: any[][] = null,
    assetId: any[][] = null,
    measure: string = null,
    alias: string = null
  ) {
    const measuresObject: Measures = {
      excludeBalanceSheetItems: false,
      excludeUndisclosedItems: false,
      excludeUnknownEntities: false,
      excludeRealizationsPriorToClosingDate: null,
      financeIndexID: null,
      financePremium: null,
      reinvestmentIndexID: null,
      reinvestmentPremium: null,
      forceRollForward: null,
      peergroupID: null,
      percentile: null,
      currency: null,
      returnConstituentCount: false,
      investmentID: String(investId).toUpperCase() == "ALL" ? "-1" : String(investId),
      portfolioID: String(portfolioId).toUpperCase() == "ALL" ? "-1" : String(portfolioId),
      isHoldingCalc: false,
      returnPooledResult: true,
      baseCurrency: String(currency).toLowerCase() === "true",
      alternateBaseCurrency: alternateCurrrency,
      adjustToMostRecent: false,
      measure: measure,
      beginDate: null,
      endDate: endDate,
      year: null,
      indexID: null,
      premium: null,
      idType: idType,
      selectionsetID: selectionSetId,
      assetID: String(assetId).toUpperCase() == "ALL" ? "-1" : String(assetId),
      weightingMethod: weightingMethod,
      value: null,
      filter: filter,
      rankValue: null,
      bMUHistoricalWindowLengthQtrs: 0,
      maxAgeDiffYears: null,
      horizon: null,
      maxDroppedPeriods: null,
      lastHistoricalEOQDate: null,
      numSimulations: null,
      desiredSampleSize: null,
      minSampleSize: null,
      sampleStatistic: null,
      stopOn: null,
      requireReportedValuation: requireReportedValuation,
      alias: alias,
      currencyHedgesetId: null,
      foFLookThrough: false,
      useReceivedDate: false,
      excludeFrozenAsset: true,
      useAlternateFundSize: false,
      dynamicParameter: null,
      universe: null,
      weight: null,
      commitment: null,
    };
    return measuresObject;
  }
}
